import { Component } from '@angular/core';
import { MetricBaseAbstract } from '../metric-base.abstract';

@Component({
    selector: 'app-gtag-metric',
    templateUrl: './gtag-metric.component.html',
    standalone: true
})
export class GtagMetricComponent extends MetricBaseAbstract {
  constructor() {super()}

  protected override onRunMetric(codes: string[]): void {
    this.runGTM(codes);
  }

  private runGTM(codes: string[]): void {
    codes.forEach(code => {
      this.loadScript('https://www.googletagmanager.com/gtag/js?id=' + code).then()
    })
  }
}
